import classnames from 'classnames';
import React from 'react';

import type { IRecord } from '@gp/types/global';
import type { IStatusTagCfg } from '../../types';

import './index.scss';

export interface IBaseStatusTagProps<T = string> {
  style?: React.CSSProperties;
  className?: string;
  isTag?: boolean;
  status?: T;
  statusList: T[];
  statusMapping: IRecord<IStatusTagCfg>;
  getStatusClassNames?: (isTag: boolean, status: T) => IRecord<boolean>;
  placeholder?: string | null;
}

const DEFAULT_STATUS_LIST: any[] = [];

const DEFAULT_STATUS_MAPPING: IRecord<IStatusTagCfg> = {};

export default function BaseStatusTag<T = string>(props: IBaseStatusTagProps<T>) {
  const {
    style,
    className,
    isTag = true,
    status = '' as T,
    statusList = DEFAULT_STATUS_LIST,
    statusMapping = DEFAULT_STATUS_MAPPING,
    getStatusClassNames,
    placeholder = null,
  } = props;

  const { text, icon } = statusMapping?.[status as keyof IRecord<IStatusTagCfg>] || {};

  if (!statusList?.includes(status))
    return !!placeholder ? (
      <span className="dbg-base-status-tag-no-data">{placeholder}</span>
    ) : null;

  return (
    <div
      style={style}
      className={classnames('dbg-base-status-tag', className, {
        ...getStatusClassNames?.(isTag, status),
        'is-transparent-bg': !isTag,
      })}
    >
      <img className="dbg-base-status-tag__icon" src={icon} alt="" />
      <label className="dbg-base-status-tag__text">{text}</label>
    </div>
  );
}
